export default __webpack_public_path__ + "static/media/allWesternCanada.02eb69d6.png";